import { render, staticRenderFns } from "./addIntoStockV4.vue?vue&type=template&id=5c10ba38&scoped=true&"
import script from "./addIntoStockV4.vue?vue&type=script&lang=js&"
export * from "./addIntoStockV4.vue?vue&type=script&lang=js&"
import style0 from "./addIntoStockV4.vue?vue&type=style&index=0&id=5c10ba38&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c10ba38",
  null
  
)

export default component.exports